import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'
import Clienti from '../views/Clienti.vue'
import Ordini from '../views/Ordini.vue'
import Statistiche from '../views/Statistiche.vue'
import Agenti from '../views/Agenti.vue'
import Elementi from '../views/Elementi.vue'
import Contratti from '../views/Contratti.vue'
import Fornitori from '../views/Fornitori.vue'
import Scadenzari from '../views/Scadenzari.vue'
import Utenti from '../components/common/Utenti.vue'
import Amministratori from '../views/Amministratori.vue'






const routes = [
    {path: '/login',  name: 'Login',    component: Login},
    {path: '/dashboard',  name: 'Dashboard',    component: Dashboard},
    {path: '/clienti',  name: 'Clienti',    component: Clienti},
    {path: '/elementi',  name: 'Elementi',    component: Elementi},
    {path: '/ordini',  name: 'Ordini',    component: Ordini},
    {path: '/statistiche',  name: 'Statistiche',    component: Statistiche},
    {path: '/agenti',  name: 'Agenti',    component: Agenti},
    {path: '/fornitori',  name: 'Fornitori',    component: Fornitori},
    {path: '/contratti',  name: 'Contratti',    component: Contratti},
    {path: '/utenti',  name: 'Utenti',    component: Utenti},
    {path: '/scadenzari',  name: 'Scadenzari',    component: Scadenzari},
    {path: '/amministratori',  name: 'Amministratori',    component: Amministratori},

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
